import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import { SubTaskStatusOptions } from 'modules/constants';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import FilterDropDownStyle from '../../../components/DropdownStyle/FilterDropDownStyle';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../../components/Search/SearchWithButton';
import {
  CommonFlex,
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';
import {
  ToggleButton,
  ToggleButtonRound,
} from '../../../components/ToggleButton/toggleButtonStyles';

const SubTaskFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  getOfficesShortList,
  officesShortList,
  selectedOffice,
  selectOffice,
  selectedMember,
  selectProject,
  selectMember,
  clearMember,
  taskStatus,
  handleStatusChange,
  selectedDate,
  handleDateChange,
  handleSearchByName,
  handleClearSearch,
  searchTerm,
  onSearchTermChange,
  selectLocation,
  selectedLocation,
  locationList,
  publicZoneList,
  selectedPublicZone,
  onPublicZoneChange,
  getTaskLocation,
  defaultSubTasks,
  selectedSubTask,
  onSubTaskChange,
  subTaskCode,
  setSubTaskCode,
  notUpdatedSince5Days,
  onNotUpdatedSince5DaysToggle,
  notUpdatedAtAll,
  onNotUpdatedAtAllToggle,
  mainTaskList,
  selectedMainTask,
  setSelectedMainTask,
}) => {
  const { t } = useTranslation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [publicZoneOptions, setPublicZoneOptions] = useState([]);
  const [subTaskOptions, setSubTaskOptions] = useState([]);
  const [mainTaskOptions, setMainTaskOptions] = useState([]);

  useEffect(() => {
    let newArr = [
      {
        label: t('all_sub_tasks'),
        value: null,
      },
    ];
    if (defaultSubTasks) {
      defaultSubTasks.forEach(subTask => {
        newArr.push({
          ...subTask,
          label: subTask.name,
          value: subTask.id,
        });
      });
    }
    setSubTaskOptions(newArr);
  }, [defaultSubTasks, t]);

  useEffect(() => {
    let newArr = [
      {
        label: t('all_tasks'),
        value: null,
      },
    ];
    if (mainTaskList) {
      mainTaskList.forEach(task => {
        newArr.push({
          ...task,
          label: task.name,
          value: task.id,
        });
      });
    }
    setMainTaskOptions(newArr);
  }, [mainTaskList, t]);
  
  const [taskLocationOptions, setTaskLocationOptions] = useState([]);
  const [memberOptions, setMemberOptions] = useState([]);
  const statusOptions = SubTaskStatusOptions?.map(option => ({
    ...option,
    label: t(option.key),
  }));
  const [selectedDates, setSelectedDates] = useState(selectedDate);
  const selectLastMonth = () => {
    setSelectedDates({
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    });
  };
  const selectLastWeek = () => {
    setSelectedDates({
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    });
  };
  const onDateApply = () => {
    handleDateChange(selectedDates);
  };
  useEffect(() => {
    getOrganizationMembersList({ office_id: null });
  }, []);

  useEffect(() => {
    if (selectedPublicZone.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    } else getOfficesShortList();
  }, [selectedPublicZone]);

  useEffect(() => {
    if (selectedOffice?.value) {
      getTaskLocation({
        office_id: selectedOffice.value,
      });
    } else getTaskLocation();
  }, [selectedOffice]);

  useEffect(() => {
    let newArr = [
      {
        label: t('all_offices'),
        value: null,
      },
    ];
    if (officesShortList && officesShortList.length > 0) {
      officesShortList.forEach(office => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      const checkSelectedOffice = newArr.find(
        office => office.value === selectedOffice?.value,
      );

      if (!checkSelectedOffice) {
        selectOffice({
          label: t('all_offices'),
          value: null,
        });
      }
    }
    setOfficeOptions(newArr);
  }, [officesShortList, t]);

  useEffect(() => {
    let newArr = [
      {
        label: t('all_public_zones'),
        value: null,
      },
    ];
    if (publicZoneList && publicZoneList.length > 0) {
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
    }
    setPublicZoneOptions(newArr);
  }, [publicZoneList, t]);

  useEffect(() => {
    if (publicZoneList?.length > 0 && !selectedPublicZone?.label && !selectedPublicZone?.value) {
      onPublicZoneChange({
        label: t('all_public_zones'),
        value: null,
      });
    }
  }, [publicZoneList]);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.value &&
      officesShortList &&
      officesShortList.length > 1
    ) {
      getOrganizationMembersList({ office_id: selectedOffice.value });
    }
  }, [selectedOffice]);

  useEffect(() => {
    let newArr = [
      {
        label: t('all_locations'),
        value: null,
      },
    ];
    if (locationList && locationList.length > 0) {
      locationList.forEach(location => {
        newArr.push({
          label: location.name,
          value: location.id,
          ...location,
        });
      });
    }
    setTaskLocationOptions(newArr);
  }, [locationList, t]);
  //   useEffect(() => {
  //     if (projectAssigneeList && projectAssigneeList.length > 0) {
  //       let assigneeList = [];
  //       projectAssigneeList.map((assignee) => {
  //         assigneeList.push({
  //           id: assignee.user.id,
  //           name: `${assignee.user.first_name}${
  //             assignee.user.last_name ? ` ${assignee.user.last_name}` : ``
  //           }`,
  //           avatar: assignee.user.avatar ? assignee.user.avatar : avatar5,
  //         });
  //       });
  //       setMemberOptions(assigneeList);
  //     } else if (projectAssigneeList && projectAssigneeList.length === 0) {
  //       setMemberOptions([]);
  //     }
  //   }, [projectAssigneeList]);

  //   useEffect(() => {
  //     if ((selectedProject && !selectedProject.value) || !selectedProject) {
  //       setMemberOptions(organizationMembersList);
  //     }
  //   }, [selectedProject]);

  const onMemberSelect = useCallback(person => {
    selectMember(person);
  }, [selectMember]);

  const clearSelectedMember = useCallback(() => {
    clearMember();
  }, [clearMember]);

  const handleSubTaskCodeChange = value => {
    setSubTaskCode(value);
    handleSearchByName(value);
  };

  const handleClearSubTaskCode = () => {
    setSubTaskCode('');
    handleClearSearch();
  };

  return (
    <FilterContainer admin={localStorage.getItem('user_role') === 'admin'}>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('public_zone')}</FilterLabel>
        <Select
          isSearchable
          value={selectedPublicZone}
          options={publicZoneOptions}
          placeholder={`${t('select_public_zone')}...`}
          onChange={e => {
            onPublicZoneChange(e);
          }}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      {/* <SearchWithButton
        itemName={t('sub_task_code')}
        label={t('search_by_sub_task_code')}
        searchTermName={t('sub_task_code')}
        searchInput={subTaskCode}
        onInputChange={e => handleSubTaskCodeChange(e.target.value)}
        handleSearch={() => handleSearchByName(subTaskCode)}
        handleClearSearch={handleClearSubTaskCode}
      /> */}
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('search_by_main_task')}</FilterLabel>
        <Select
          isSearchable
          value={selectedMainTask}
          options={mainTaskOptions}
          placeholder={`${t('select_master_tasks')}...`}
          onChange={setSelectedMainTask}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('sub_task')}</FilterLabel>
        <Select
          isSearchable
          value={selectedSubTask}
          options={subTaskOptions}
          placeholder={`${t('select_sub_task')}...`}
          onChange={e => {
            onSubTaskChange(e);
          }}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('office')}</FilterLabel>
        <Select
          isSearchable
          value={selectedOffice}
          options={officeOptions}
          placeholder="Select Office..."
          onChange={e => {
            selectOffice(e);
          }}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>

      <InputWithLabelSection width="200px">
        <FilterLabel>{t('location')}</FilterLabel>
        <Select
          isSearchable
          value={selectedLocation}
          options={taskLocationOptions}
          placeholder={`${t('select_location')}...`}
          onChange={selectLocation}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      {/* {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('assignee')}</FilterLabel>
          <div style={{ width: `40px` }}>
            <AddSingleMemberDropdown
              assigneeManage={selectedMember}
              updateState={onMemberSelect}
              membersList={organizationMembersList}
              clearAssignee={() => clearMember()}
            />
          </div>
        </InputWithLabelSection>
      )} */}
      {/* <SearchWithButton
        itemName={''}
        label={t('search_task')}
        searchTermName={t('task_name')}
        searchInput={searchTerm}
        onInputChange={onSearchTermChange}
        handleSearch={handleSearchByName}
        handleClearSearch={handleClearSearch}
      /> */}
      <InputWithLabelSection>
        <FilterLabel>{t('date_range')}</FilterLabel>
        {/* <DatePicker
          id="createIssuedDate"
          date={selectedDate}
          onDateChange={handleDateChange}
          dateDisplayFormat={'DD/MM/YYYY'}
          placeholder={'Select date'}
          allowPreviousDates
        /> */}
        <ReactDateRangePicker
          startDate={selectedDates.startDate ? selectedDates.startDate : null}
          startDateId="custom-date-range-start-date"
          endDate={selectedDates.endDate ? selectedDates.endDate : null}
          endDateId="custom-date-range-start-date"
          onDatesChange={setSelectedDates}
          dateDisplayFormat="DD/MM/YYYY"
          onDateSelect={onDateApply}
          selectLastWeek={selectLastWeek}
          selectLastMonth={selectLastMonth}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="160px">
        <FilterLabel>{t('status')}</FilterLabel>
        <Select
          isSearchable={false}
          value={taskStatus}
          options={statusOptions}
          placeholder="Status"
          onChange={e => {
            handleStatusChange(e);
          }}
          styles={FilterDropDownStyle({
            height: '40px',
            width: '130px',
            menuWidth: '130px',
          })}
        />
      </InputWithLabelSection>
      <InputWithLabelSection>
        <CommonFlex
          justifyContent="flex-end"
          gap="15px"
          alignItems="flex-end"
        >
          <CommonFlex padding='10px' bgColor='white' style={{borderRadius: '5px'}}  gap="8px" alignItems="center">
            <ToggleButton
              active={notUpdatedSince5Days}
              onClick={onNotUpdatedSince5DaysToggle}
              width="32px"
              height="20px"
            >
              <ToggleButtonRound active={notUpdatedSince5Days} />
            </ToggleButton>
            <FilterLabel margin="0">
              {t('not_updated_since_last_5_days')}
            </FilterLabel>
          </CommonFlex>
          <CommonFlex padding='10px' bgColor='white' style={{borderRadius: '5px'}} gap="8px" alignItems="center">
            <ToggleButton
              active={notUpdatedAtAll}
              onClick={onNotUpdatedAtAllToggle}
              width="32px"
              height="20px"
            >
              <ToggleButtonRound active={notUpdatedAtAll} />
            </ToggleButton>
            <FilterLabel margin="0">
              {t('not_updated_at_all')}
            </FilterLabel>
          </CommonFlex>
        </CommonFlex>
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default SubTaskFilter;
